// extracted by mini-css-extract-plugin
export default {"result":"ResultTable_result__INwR+"};